module.exports = __webpack_public_path__ + "static/media/copyEnable.41b04c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/copyEnable.png
// module id = 1326
// module chunks = 0